module.exports = __webpack_public_path__ + "img/upload-file-icon.b224e597.svg";